import { render, staticRenderFns } from "./TestsEditor.vue?vue&type=template&id=3d1e55da&scoped=true"
import script from "./TestsEditor.vue?vue&type=script&lang=js"
export * from "./TestsEditor.vue?vue&type=script&lang=js"
import style0 from "./TestsEditor.vue?vue&type=style&index=0&id=3d1e55da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1e55da",
  null
  
)

export default component.exports